module.exports = __webpack_public_path__ + "media/flags/ms-88a8b417.svg";